import React, {useContext} from "react";
import styled from "styled-components";
import { AppContext } from "../context/AppContext";
import useCourseRetriever from "../hooks/useCourseRetriever";

export const CourseRefresh = ({ time }) => {
  const {appState} = useContext(AppContext)
  useCourseRetriever(appState.course.id, time)
  
  return (
    <RefreshNotifier>
      Updated at {time}
    </RefreshNotifier>
  )
}

const RefreshNotifier = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 0.6rem;
  color: ${({theme}) => theme.text};
  opacity: 0.5;
`